import list from './cardView';
export default list;
// return;
// console.log("in")
// import cardView from './cardView';
// export default cardView;
